import { mobile, styled } from '@obvio/app'
import { RichText } from '@obvio/template'
import { Stack } from '@obvio/ui'
import { Children, cloneElement, useCallback } from 'react'

import { CenteredSection } from '../CenteredSection'
import { useCursorContext } from '../Cursor'
import { ReadMoreLink } from '../ReadMoreLink'

import type { ReactElement } from 'react'

const Interactive = styled.div`
  @media ${mobile} {
    display: none;
  }
`

// TODO: I'd rather not do that, hydration issue mentioned below
const MobileStack = styled(Stack)`
  display: none;
  @media ${mobile} {
    display: block;
  }
`

const Section = styled(CenteredSection)`
  margin-top: ${(theme) => `calc(${theme.spacing.extraLarge} * 3)`};
  margin-bottom: ${(theme) => `calc(${theme.spacing.extraLarge} * 3)`};
  h2 {
    max-width: 45.5625rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
  }
  h2:last-of-type {
    margin-bottom: ${(theme) => theme.spacing.medium};
  }
  p {
    max-width: 53.75rem;
    margin-left: auto;
    margin-right: auto;
  }

  @media ${mobile} {
    margin-top: ${(theme) => theme.spacing.extraLarge};
    margin-bottom: ${(theme) => theme.spacing.extraLarge};
  }
`

const RSVPLink = styled(ReadMoreLink)`
  justify-content: center;
`

type WrapProps = {
  children: ReactElement
}

// TODO: figure out the best way to render components dynamically based on useIsMobile.
// This is no longer a valid usage cause of hydration mismatch.
function Wrap({ children }: WrapProps): ReactElement {
  const { setValue } = useCursorContext()

  const scrollToBottom = useCallback(() => {
    const rsvpElement = document.querySelector('#rsvp')
    if (!rsvpElement) {
      return
    }

    window.scrollTo({
      top: (rsvpElement as HTMLElement).offsetTop - 100,
      behavior: 'smooth',
    })
  }, [])

  return (
    <>
      <Interactive
        onMouseLeave={() => setValue(null)}
        onMouseEnter={() => setValue('RSVP')}
        onClick={scrollToBottom}
      >
        {children}
      </Interactive>
      <MobileStack kind="vertical" spacing="medium">
        <>{Children.map(children, (child) => cloneElement(child))}</>
        <RSVPLink onClick={scrollToBottom}>RSVP</RSVPLink>
      </MobileStack>
    </>
  )
}

type EventDescriptionProps = {
  description: string
}

export function EventDescription({
  description,
}: EventDescriptionProps): ReactElement {
  return (
    <Section>
      <Wrap>
        <RichText value={description} asMap={{ h2: 'h4' }} />
      </Wrap>
    </Section>
  )
}
